import React from 'react'
import Button from './button'

export default function TextButton({children, className='', ...props}) {
  return (
    <Button button={'link'} className={`p-0 ${className}`} {...props} ouline={false}>{children}</Button>
  )
}
